module.exports = __webpack_public_path__ + "img/iconArrowRight.ab07d142.svg";